module.exports = __webpack_public_path__ + "static/media/P4D_Loader.232f1796.gif";